<div class="spinner-wrapper">
    <img src="assets/gif/loader.gif" alt="IPOSPAYS LOADER" width="110" />
</div>